import { apiGet, apiPost } from '../services/api';

export interface Notification {
  id: number;
  title: string;
  message: string;
  arabic_message: string;
  english_message: string;
  type: string;
  read: boolean;
  created_at: string;
  data?: Record<string, any>;
  notification_type?: string;
  related_leave_request?: {
    id: number;
  };
  related_installment?: {
    order: {
      id: number;
    };
  };
  related_broadcast_message?: {
    id: number;
  };
}

export interface NotificationsResponse {
  data: Notification[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export async function getNotifications(page: number = 1): Promise<NotificationsResponse> {
  return apiGet<NotificationsResponse>(`/api/my-notifications?page=${page}`);
}

export async function markAsRead(notificationIds: number[]): Promise<void> {
  return apiPost<void>('/api/notifications/mark-as-read', {
    notification_ids: notificationIds,
  });
}

export async function markAllAsRead(): Promise<void> {
  return apiPost<void>('/api/notifications/mark-all-as-read', {});
}

